import { render, staticRenderFns } from "./comment-form.vue?vue&type=template&id=709b6665&scoped=true&"
import script from "./comment-form.vue?vue&type=script&lang=js&"
export * from "./comment-form.vue?vue&type=script&lang=js&"
import style0 from "./comment-form.vue?vue&type=style&index=0&id=709b6665&scoped=true&lang=scss&"
import style1 from "./comment-form.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709b6665",
  null
  
)

export default component.exports